import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from 'react';
import { getBuyerPaymentTransactions, getPaymentTransactions } from '../../../Redux/Payment/action';
import { IMAGE_URL } from '../../../api';
import { BiRupee } from 'react-icons/bi';
import InfiniteScroll from 'react-infinite-scroll-component';


const PaymentHistoryBuyer = () => {

    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(new Date());
    const [credittransactions, setCreditTransactions] = useState([]);
    const [debittransactions, setDebitTransactions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        getTransactionData(startDate)

    }, []);
    const onChangeDate = (date) => {
        setStartDate(date)
        getTransactionData(date)
    }
    const getTransactionData = (date) => {
        let formData = new FormData();
        // formData.append('date_from', moment(date).format('YYYY-MM-DD'))
        // formData.append('date_to', moment(date).add(1, 'd').format('YYYY-MM-DD'))
        formData.append('status', 2)
        formData.append('page', currentPage)
        formData.append('per_page', 9)
        getPaymentTransactions({ formData })((response) => {
            if (response && response.status) {
                setHasMore(false)
                setCreditTransactions(response?.data?.data)
            }
        });
        getBuyerPaymentTransactions({ formData })((response) => {
            if (response && response.status) {
                setDebitTransactions(response?.data?.data)
            }
        });
    }
    const downloadInvoice = (download) => {
        var a = document.createElement('a')
        a.href = IMAGE_URL + download
        a.target = '_blank'
        // a.download = 
        a.click();
    }
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const paginate = () => {

        getPaymentTransactions(page, 9)((response) => {
            if (response.status) {

                if ((credittransactions.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setCreditTransactions(credittransactions.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Payment History </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Payment History</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='my-tasks'>
                <div className='container'>
                    <div className='row'>
                        <Tab.Container id="" defaultActiveKey="first">
                            <Row>
                                <Col sm={12}>
                                    <Nav variant="pills" className="">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">Debited</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">Credited</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <div className='showing-date'>
                                            <h5 className='posted-tasks'>Showing</h5>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date: Date) => onChangeDate(date)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Col sm={12}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <section className="paymenthist-buyer section-bg p-0">
                                                <div className="container">
                                                    <div className="row">
                                                        {transactions?.map((transaction, index) =>
                                                            <React.Fragment>
                                                                {transaction?.type_of_transaction == 'DEBITED' &&
                                                                    <div className="col-lg-4 mb-3" key={index}>
                                                                        <div className="member d-flex align-items-start">
                                                                            <div className="member-info">
                                                                                <h4>{transaction?.task_details?.title}</h4>
                                                                                <p><i className="bi bi-calendar"></i> {moment(transaction?.created_date).format('ll')}</p>
                                                                                <p className='amount-debited fw-bold'>{transaction?.invoice_details?.amount}</p>
                                                                                <p>Method of transaction : {transaction?.invoice_details?.method} TRANSFER</p>
                                                                                <div className='status'>
                                                                                    <p>Status: </p>
                                                                                    {transaction?.status == 'SUCCESSFUL' ?
                                                                                        <span className="badge badge-light-success">Successful</span>
                                                                                        :
                                                                                        <span className="badge badge-light-warning">{transaction?.status}</span>

                                                                                    }
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )}
                                                    </div>

                                                </div>
                                            </section>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <section className="paymenthist-buyer section-bg p-0">
                                                <div className="container">
                                                    <div className="row">
                                                        {transactions?.map((transaction, index) =>
                                                            <React.Fragment>
                                                                {transaction?.type_of_transaction == 'CREDITED' &&
                                                                    <div className="col-lg-4 mb-3" key={index}>
                                                                        <div className="member d-flex align-items-start">
                                                                            <div className="member-info">
                                                                                <h4>{transaction?.task_details?.title}</h4>
                                                                                <p><i className="bi bi-calendar"></i> {moment(transaction?.created_date).format('ll')}</p>
                                                                                <p className='amount-debited fw-bold'>{transaction?.invoice_details?.amount}</p>
                                                                                <p>Method of transaction : {transaction?.invoice_details?.method} TRANSFER</p>
                                                                                <div className='status'>
                                                                                    <p>Status: </p>
                                                                                    {transaction?.status == 'SUCCESSFUL' ?
                                                                                        <span className="badge badge-light-success">Successful</span>
                                                                                        :
                                                                                        <span className="badge badge-light-warning">{transaction?.status}</span>

                                                                                    }
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )}

                                                    </div>

                                                </div>
                                            </section>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </section> */}
            <section id="features" className="features">
                <div className="container">

                    <ul className="nav nav-tabs row gy-4 d-flex">

                        <li className="nav-item col-6 col-md-4 col-lg-4">
                            <a className="nav-link active show" data-bs-toggle="tab" data-bs-target="#tab-1">
                                <i className="bi bi-credit-card"></i>
                                <h4>Debited</h4>
                            </a>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-4">
                            <a className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-2">
                                <i className="bi bi-credit-card-2-front"></i>
                                <h4>Credited</h4>
                            </a>
                        </li>

                    </ul>

                    <div className="tab-content">

                        <div className="tab-pane active show" id="tab-1">
                            <section className="paymenthist-buyer section-bg p-0">
                                <InfiniteScroll
                                    dataLength={debittransactions.length}
                                    next={paginate}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="container">
                                        <div className="row">
                                            {debittransactions?.map((transaction, index) =>
                                                <React.Fragment key={index}>
                                                    <div className="col-lg-4 mb-3" onClick={() => navigate('/paymenthistorylist/' + transaction?.task_details[0]?.id)}>
                                                        <div className="member d-flex align-items-start">
                                                            <div className="member-info">
                                                                <span className="badge badge-light-primary mb-4">Transaction id : {transaction?.transaction_id}</span>
                                                                {/* <p className='transactionid mb-2'>Transaction id : {transaction?.transaction_id}</p> */}
                                                                <h4>Task: {transaction?.task_details[0]?.title}</h4>
                                                                {transaction?.task_details[0] == null ?
                                                                    <></>
                                                                    :
                                                                    <p className='amount-debited fw-bold' style={{ display: "flex", alignItems: "center" }}><BiRupee size="20" style={{ color: "#000" }} />{parseFloat(transaction?.task_details[0]?.final_price).toFixed(2)}</p>
                                                                }
                                                                <p>Method of transaction : {transaction?.method_of_transaction}</p>
                                                                <p><i className="bi bi-calendar"></i> {moment(transaction?.created_date).format('ll')}</p>
                                                                <div className='status'>
                                                                    <p>Status: </p>
                                                                    {transaction?.status == 'SUCCESSFUL' ?
                                                                        <span className="badge badge-light-success">Successful</span>
                                                                        :
                                                                        <span className="badge badge-light-warning">{transaction?.status}</span>

                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>

                                    </div>
                                </InfiniteScroll>
                            </section>
                        </div>

                        <div className="tab-pane" id="tab-2">
                            <section className="paymenthist-buyer section-bg p-0">
                                <InfiniteScroll
                                    dataLength={credittransactions.length}
                                    next={paginate}
                                    hasMore={hasMore}
                                    loader={<p style={{ textAlign: 'center' }}>
                                        <b>Loading...</b>
                                    </p>}
                                    endMessage={
                                        <p style={{ textAlign: 'center' }}>
                                            <b>Yay! You have seen it all</b>
                                        </p>
                                    }
                                >
                                    <div className="container">
                                        <div className="row">
                                            {credittransactions?.map((transaction, index) =>
                                                <React.Fragment key={index}>

                                                    {transaction?.type_of_transaction == 'CREDITED' &&
                                                        <div className="col-lg-4 mb-3">
                                                            <div className="member d-flex align-items-start">
                                                                <div className="member-info">
                                                                    <span className="badge badge-light-primary mb-4">Transaction id : {transaction?.transaction_id}</span>

                                                                    <h4>{transaction?.task_details[0]?.title}</h4>
                                                                    <p className='amount-debited fw-bold' style={{ display: "flex", alignItems: "center" }}><BiRupee size="20" style={{ color: "#000" }} />{parseFloat(transaction?.transferred_amount).toFixed(2)}</p>
                                                                    <p>Method of transaction : {transaction?.invoice_details?.method} TRANSFER</p>
                                                                    <p><i className="bi bi-calendar"></i> {moment(transaction?.created_date).format('ll')}</p>
                                                                    <div className='status mb-4'>
                                                                        <p>Status: </p>
                                                                        {transaction?.status == 'SUCCESSFUL' ?
                                                                            <span className="badge badge-light-success">Successful</span>
                                                                            :
                                                                            <span className="badge badge-light-warning">{transaction?.status}</span>

                                                                        }
                                                                    </div>
                                                                    {transaction?.invoice_details?.invoice_pdf != null &&
                                                                        <div className='text-center'>
                                                                            <button className='badge badge-light-danger border-0 p-2 fs-7' onClick={() => downloadInvoice(transaction?.invoice_details?.invoice_pdf)}>
                                                                                Download Invoice
                                                                            </button>
                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )}

                                        </div>

                                    </div>
                                </InfiniteScroll>
                            </section>
                        </div>

                    </div>

                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default PaymentHistoryBuyer;